import React from 'react'
import { Text, Grid, Box, UnstyledButton, Card, Group,} from '@mantine/core'

const ShipmentMethodCard = ({ item, selected, onClick }) => {
    const Icon = item.icon
    return (
        <UnstyledButton
            onClick={() => onClick(item.value)}
            w="100%"
        >
            <Card
                withBorder
                padding="sm"
                radius="md"
                bg={selected ? 'blue.0' : 'white'}
                style={{
                    borderColor: selected ? 'var(--mantine-color-blue-5)' : undefined,
                    transition: 'all 0.2s'
                }}
            >
                <Group>
                    <Icon size={18} color={selected ? 'var(--mantine-color-blue-6)' : 'var(--mantine-color-gray-6)'} />
                    <Text size="xs" fw={500} c={selected ? 'blue.7' : 'dimmed'}>{item.label}</Text>
                    {selected && (
                        <Group style={{ marginLeft: 'auto' }}>
                            <div style={{ backgroundColor: 'var(--mantine-color-blue-6)', borderRadius: '50%', padding: '2px', display: 'flex' }}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                        </Group>
                    )}
                </Group>
            </Card>
        </UnstyledButton>
    )
}

const ShipmentMethodSection = ({ methodGroups, availableMethods, handleToggleMethod }) => {
    return (
        <>
            <Text fw={600} mb="sm">Available Shipment Method</Text>
            <Grid>
                <Grid.Col span={6}>
                    <Box mb="sm">
                        <Text size="xs" c="dimmed" mb={5}>Official</Text>
                        <Grid>
                            {methodGroups.official.map(item => (
                                <Grid.Col span={6} key={item.value}>
                                    <ShipmentMethodCard
                                        item={item}
                                        selected={availableMethods.includes(item.value)}
                                        onClick={handleToggleMethod}
                                    />
                                </Grid.Col>
                            ))}
                        </Grid>
                    </Box>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Box mb="sm">
                        <Text size="xs" c="dimmed" mb={5}>Un Official</Text>
                        <Grid>
                            {methodGroups.unofficial.map(item => (
                                <Grid.Col span={6} key={item.value}>
                                    <ShipmentMethodCard
                                        item={item}
                                        selected={availableMethods.includes(item.value)}
                                        onClick={handleToggleMethod}
                                    />
                                </Grid.Col>
                            ))}
                        </Grid>
                    </Box>
                </Grid.Col>
            </Grid>
        </>
    )
}

export default ShipmentMethodSection
